'use client';

import { Menu, Text } from '@terra/ui-design-system';
import { HStack } from '@terra/ui-styled-system';
import {
  Download01Icon,
  FileSpreadsheetIcon,
  File01Icon,
} from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import {
  COPILOT_SESSION_EXPORT_FORMAT,
  type CoPilotSessionExportFormat,
} from './copilot-session-export-formats';

export const COPILOT_SESSION_EXPORT_MENU_ITEMS: Array<{
  format: CoPilotSessionExportFormat;
  icon: typeof File01Icon;
  labelKey: 'exportAsMarkdown' | 'exportAsCsv' | 'exportHarOnly';
}> = [
  {
    format: COPILOT_SESSION_EXPORT_FORMAT.MARKDOWN,
    icon: File01Icon,
    labelKey: 'exportAsMarkdown',
  },
  {
    format: COPILOT_SESSION_EXPORT_FORMAT.CSV,
    icon: FileSpreadsheetIcon,
    labelKey: 'exportAsCsv',
  },
  {
    format: COPILOT_SESSION_EXPORT_FORMAT.HAR,
    icon: Download01Icon,
    labelKey: 'exportHarOnly',
  },
];
type CoPilotSessionExportMenuItemsProps = {
  disabled?: boolean;
  exportingFormat: CoPilotSessionExportFormat | null;
  onExport: (format: CoPilotSessionExportFormat) => void;
};

export function CoPilotSessionExportMenuItems({
  disabled = false,
  exportingFormat,
  onExport,
}: CoPilotSessionExportMenuItemsProps) {
  const t = useTranslations('chat.copilot.toolbar');

  return (
    <>
      {COPILOT_SESSION_EXPORT_MENU_ITEMS.map(
        ({ format, icon: Icon, labelKey }) => {
          const isItemExporting = exportingFormat === format;
          const isItemDisabled = disabled || exportingFormat !== null;

          return (
            <Menu.Item
              key={format}
              value={format}
              disabled={isItemDisabled}
              fontSize="xs"
              py="1"
              px="2"
              onClick={() => {
                onExport(format);
              }}
            >
              <HStack gap="1.5">
                <Icon size={12} />
                <Text fontSize="xs">
                  {isItemExporting ? t('exporting') : t(labelKey)}
                </Text>
              </HStack>
            </Menu.Item>
          );
        },
      )}
    </>
  );
}
